import React from "react"
import { Col, Row, Container } from "react-bootstrap"
import RehabImage from "../../images/find-rehab-img.png"

const WhyFindRehab = () => {
  return (
    <section id="why-rehab-find">
      <Container className="container">
        <Row>
          <Col md={4}>
            <img src={RehabImage} alt="" className="side-img" />
          </Col>
          <Col md={8}>
            <h1>Why Rehab Find?</h1>
            <p>
              After working with hundreds of patients, we’ve identified two
              major challenges that people face when seeking treatment options
              online.
            </p>
            {/* <!-- row inside column --> */}
            <Row className="inner-text">
              <Col md={5} className=" offset-md-1">
                <p>
                  {" "}
                  <span className="circle"></span> First, it’s very difficult to
                  find medical professionals online. Popular search engines are
                  designed to take you to the closest doctor rather than showing
                  you the most relevant specialist for your needs.
                </p>
              </Col>
              <Col md={5}>
                <p>
                  <span className="circle"></span> Second, the rehabilitation is
                  a reasonably popular destination for scam artists and
                  hucksters looking to take people’s money with little
                  accountability and little in the way of true professional
                  treatment.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col md={8} className="offset-md-4 bottom-desc d-flex">
            <div className="divider pr-4"> </div>
            <p>
              Rehab Find has solved both of these problems by creating and
              vetting a database of treatment professionals across the entire
              country of Canada. We can provide you with a full list of vetted
              specialists by province, specialty or both, allowing you to
              quickly find the treatment desired.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default WhyFindRehab
